import moment from 'moment';
import React, { useEffect, useState } from "react";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

/** Bootstrap */
import {
    Button,
    Col,
    Container,
    Form,
    FormGroup,
    FormLabel,
    Row
} from 'react-bootstrap';

/** Servicios */
import observacionService from "../services/observacion.service";
import trabajadorService from "../services/trabajador.service";

const ObservacionTrabajador = () => {
    const [loading, setLoading] = useState(false);
    const [observacion, setObservacion] = useState('');
    const { id_trabajador } = useParams();
    const [trabajador, setTrabajador] = useState('');

    useEffect(() => {
        if (id_trabajador) {
            const rut = atob(id_trabajador);
            retreiveTrabajador(rut);
        }
    }, []);

    function retreiveTrabajador(rut) {
        trabajadorService.buscarPorRut(rut)
            .then(resp => {
                setTrabajador(resp.data[0]);
            })
            .catch(err => {
                console.error(err);
            });
    };

    const ingresarObservacion = () => {
        setLoading(true);
        observacionService.create({ descripcion: observacion, trabajadorId: trabajador.id })
            .then(resp => {
                retreiveTrabajador(atob(id_trabajador));
                setLoading(false);
                toast.info("Observación ingresada exitosamente!!", {
                    autoClose: 3000,
                });
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
                toast.error("Ocurrio un error al ingresar la observación", {
                    autoClose: 3000,
                });
            });
    };

    function dateFormat(cell, row) {
        return row.createdAt === null ? "" : moment(row.createdAt).format("DD-MM-YYYY HH:mm");
    }

    return (
        <Container>
            <Row>
                <div class="d-flex justify-content-center">
                    <div class="col-md-7">
                        <div class="card p-3 py-4">

                            <div class="text-center">
                                <span class="rounded-circle p-3 bg-success text-white">E</span>
                                <div className="mt-2"></div>
                                {/* <img src="https://i.imgur.com/bDLhJiP.jpg" width="100" class="rounded-circle"> */}
                            </div>

                            <div class="text-center mt-3">
                                <span class="bg-secondary p-1 px-4 rounded text-white">{trabajador.centro_costo}</span>
                                <h5 class="mt-2 mb-0">{trabajador.nombre + " " + trabajador.ap_paterno + " " + trabajador.ap_materno}</h5>
                                <span>{trabajador.cargo}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </Row>
            <Row>
                <Col>
                    <FormGroup className="m-3">
                        <FormLabel>Observación</FormLabel>
                        <Form.Control as="textarea" rows={3} placeholder="Observación" onChange={(e) => setObservacion(e.target.value)} />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col></Col>
                <Col></Col>
                <Col>
                    <div className="d-flex justify-content-end m-3">
                        <Button variant="primary" onClick={ingresarObservacion}>Ingresar {loading && (<span className="spinner-border spinner-border-sm"></span>)}</Button>
                    </div>
                </Col>
            </Row>
            <div className="mt-3"></div>
            <Row>
                <Col>
                    <div className="d-flex justify-content-lg-start m-3">
                        <h4 className="text-center">Observaciones:</h4>
                    </div>
                    <div className="d-flex justify-content-center m-3">
                        <div className="mt-1"></div>
                        <BootstrapTable data={trabajador.observaciones} hover version="4">
                            <TableHeaderColumn dataField="id" isKey hidden>ID</TableHeaderColumn>
                            <TableHeaderColumn dataField="descripcion" width='300'>Observación</TableHeaderColumn>
                            <TableHeaderColumn dataFormat={dateFormat} width='150'>Fecha</TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default ObservacionTrabajador;